import fetch from '../utils/fetch'
// 怡贝会员列表
export function membersList (query) {
  return fetch({
    url: '/members/list',
    method: 'get',
    params: query
  })
}
// 会员详情
export function membersInfo (query) {
  return fetch({
    url: '/members/detail',
    method: 'get',
    params: query
  })
}
// 会员编辑
export function updateMembersInfo (query) {
  return fetch({
    url: '/members/edit',
    method: 'patch',
    params: query
  })
}
// 会员列表导出
export function membersExport (query) {
  return fetch({
    url: '/members/export',
    method: 'GET',
    params: query
  })
}
// 会员等级列表
export function membersLvList (query) {
  return fetch({
    url: '/memberLv/list',
    method: 'get',
    params: query
  })
}
// 会员等级编辑
export function updateMemberLvInfo (query) {
  return fetch({
    url: '/memberLv/updateMemberLvInfo',
    method: 'patch',
    params: query
  })
}
// 提现列表
export function withdrawList (query) {
  return fetch({
    url: '/withdraw/list',
    method: 'get',
    params: query
  })
}
// 员工提现工资表
export function stafftixianList (query) {
  return fetch({
    url: '/stafftixian/list',
    method: 'get',
    params: query
  })
}
// 员工提现工资表表导出
export function stafftixianExport (query) {
  return fetch({
    url: '/stafftixian/export',
    method: 'GET',
    params: query
  })
}
// 提现审核
export function withdrawExamine (query) {
  return fetch({
    url: '/withdraw/examine',
    method: 'patch',
    params: query
  })
}
// 提现批量审核
export function withdrawShenhe (query) {
  return fetch({
    url: '/withdraw/shenhe',
    method: 'post',
    data: query
  })
}
// 提现结算
export function withdrawSettlement (query) {
  return fetch({
    url: '/withdraw/settlement',
    method: 'patch',
    params: query
  })
}
// 提现批量结算
export function withdrawJiesuan (query) {
  return fetch({
    url: '/withdraw/jiesuan',
    method: 'post',
    data: query
  })
}
// 提现列表导出
export function withdrawExport (query) {
  return fetch({
    url: '/withdraw/export',
    method: 'GET',
    params: query
  })
}
// 活动图片列表
export function iconsList (query) {
  return fetch({
    url: '/icons/list',
    method: 'get',
    params: query
  })
}
// 活动图片编辑
export function updateIcon (query) {
  return fetch({
    url: '/icons/updateIcon',
    method: 'patch',
    params: query
  })
}
// 删除活动图片
export function deleteIcons (id) {
  return fetch({
    url: '/icons/list/' + id,
    method: 'delete'
  })
}
// 活动设置列表
export function activityList (query) {
  return fetch({
    url: '/activity/list',
    method: 'get',
    params: query
  })
}
// 活动添加
export function createActivity (params) {
  return fetch({
    url: '/activity/createActivity',
    method: 'post',
    params: params
  })
}
 // 活动编辑
export function updateActivity (params) {
  return fetch({
    url: '/activity/updateActivity',
    method: 'put',
    params: params
  })
}
// 活动排序编辑
export function activitySortEdit (query) {
  return fetch({
    url: '/activity/sortEdit',
    method: 'patch',
    params: query
  })
}
// 获取活动信息
export function activityGetInfo (params) {
  return fetch({
    url: '/activity/getActivityInfo',
    method: 'get',
    params: params
  })
}
// 获取活动商品列表
export function getActivityhotList (params) {
  return fetch({
    url: '/activityhot/getActivityhotList',
    method: 'get',
    params: params
  })
}
// 删除活动信息
export function deleteItems (act_id) {
  return fetch({
    url: '/activity/list/' + act_id,
    method: 'delete'
  })
}
// 商品列表
export function getSkuList (query) {
  return fetch({
    url: '/sku/list',
    method: 'get',
    params: query
  })
}
// 商品编辑
export function updateSkuListInfo (query) {
  return fetch({
    url: '/sku/edit',
    method: 'patch',
    params: query
  })
}
// 删除商品
export function deleteSku (id) {
  return fetch({
    url: '/sku/list/' + id,
    method: 'delete'
  })
}
// 商品同步怡贝
export function yibeiSync (query) {
  return fetch({
    url: '/sku/yibeiSync',
    method: 'post',
    data: query
  })
}
// 商品列表导出
export function skuExport (query) {
  return fetch({
    url: '/sku/export',
    method: 'GET',
    params: query
  })
}
// 商品分类列表
export function getSkuCate (query) {
  return fetch({
    url: '/sku/cate',
    method: 'get',
    params: query
  })
}
// 更新单条分类信息
export function updateSkuCate(id, query) {
  return fetch({
    url: '/sku/cate/' + id,
    method: 'put',
    data: query
  })
}
// 健康合伙人申请列表
export function getHhmemberList (query) {
  return fetch({
    url: '/shenqing/list',
    method: 'get',
    params: query
  })
}
// 健康合伙人申请列表导出
export function hhmemberExport (query) {
  return fetch({
    url: '/shenqing/export',
    method: 'GET',
    params: query
  })
}
// 分享点击列表
export function getClickList (query) {
  return fetch({
    url: '/click/list',
    method: 'get',
    params: query
  })
}
// 分享点击列表导出
export function clickExport (query) {
  return fetch({
    url: '/click/export',
    method: 'GET',
    params: query
  })
}
// 经营统计
export function getJingying (query) {
  return fetch({
    url: '/tongji/jingying',
    method: 'get',
    params: query
  })
}
// 推客排行
export function getTuikeRanking (query) {
  return fetch({
    url: '/tongji/tuikeRanking',
    method: 'get',
    params: query
  })
}
// 员工签到管理
export function getQianDao (query) {
  return fetch({
    url: '/tongji/qianDao',
    method: 'get',
    params: query
  })
}
// 分享点击列表导出
export function tuikeExport (query) {
  return fetch({
    url: '/tongji/tuikeExport',
    method: 'GET',
    params: query
  })
}
// 优选分享签到列表导出
export function qiandaoExport (query) {
  return fetch({
    url: '/tongji/qiandaoExport',
    method: 'GET',
    params: query
  })
}
// 推客排行（点击量）
export function getTuikeRankingClick (query) {
  return fetch({
    url: '/tongji/tuikeRankingClick',
    method: 'get',
    params: query
  })
}
// 商品排行(点击量)
export function getGoodsRankingClick (query) {
  return fetch({
    url: '/tongji/goodsRankingClick',
    method: 'get',
    params: query
  })
}
// 商品排行(订单量)
export function getGoodsRankingOrder (query) {
  return fetch({
    url: '/tongji/goodsRankingOrder',
    method: 'get',
    params: query
  })
}
// 商品排行(订单量)
export function getOrderTongji (query) {
  return fetch({
    url: '/tongji/orderTongji',
    method: 'get',
    params: query
  })
}
// banner列表
export function bannericonList (query) {
  return fetch({
    url: '/bannericon/list',
    method: 'get',
    params: query
  })
}
// banner编辑
export function updateBannericon (query) {
  return fetch({
    url: '/bannericon/updateIcon',
    method: 'patch',
    params: query
  })
}
// 删除banner
export function deleteBannericon (id) {
  return fetch({
    url: '/bannericon/list/' + id,
    method: 'delete'
  })
}
// banner排序编辑
export function bannerSortEdit (query) {
  return fetch({
    url: '/bannericon/sortEdit',
    method: 'patch',
    params: query
  })
}
// 订单列表
export function getYbordersList (query) {
  return fetch({
    url: '/yborders/list',
    method: 'get',
    params: query
  })
}
// 订单列表导出
export function ybordersExport (query) {
  return fetch({
    url: '/yborders/export',
    method: 'GET',
    params: query
  })
}
// 钱包明细列表
export function getAdvanceList (query) {
  return fetch({
    url: '/advance/list',
    method: 'get',
    params: query
  })
}

// 平台奖励资金明细列表
export function getPlatformRewardList (query) {
  return fetch({
    url: '/advance/platformRewardList',
    method: 'get',
    params: query
  })
}
// 资金明细导出
export function platformRewardListExport (query) {
  return fetch({
    url: '/advance/platformRewardList/export',
    method: 'get',
    params: query
  })
}
// 员工佣金明细导出
export function memberAdvanceDetailExport (query) {
  return fetch({
    url: '/advance/memberAdvanceDetail/export',
    method: 'get',
    params: query
  })
}
// 团长奖励待发放列表
export function getRewardPendingList (query) {
  return fetch({
    url: '/advance/rewardPendingList',
    method: 'get',
    params: query
  })
}
// 团长奖励审核（通过/审核不通过）
export function rewardPendingAudit (params) {
  return fetch({
    url: '/advance/rewardPending/audit',
    method: 'patch',
    params: params
  })
}
// 团长奖励添加或修改审核备注
export function rewardPendingUpdateRemark (params) {
  return fetch({
    url: '/advance/rewardPending/remark',
    method: 'patch',
    params: params
  })
}
// 团长奖励待发放导出
export function rewardPendingListExport (query) {
  return fetch({
    url: '/advance/rewardPendingList/export',
    method: 'get',
    params: query
  })
}
// 团长奖励-导入员工数据
export function importRewardEmployee (data) {
  return fetch({
    url: '/advance/rewardEmployee/import',
    method: 'post',
    data: data
  })
}
// 管理员充值
export function advanceChange (params) {
  return fetch({
    url: '/advance/advanceChange',
    method: 'post',
    params: params
  })
}
// 优卡钱包明细列表
export function getBenfitAdvanceList (query) {
  return fetch({
    url: '/benfitAdvance/list',
    method: 'get',
    params: query
  })
}
// 优卡交易明细列表导出
export function benfitAdvanceExport (query) {
  return fetch({
    url: '/benfitAdvance/export',
    method: 'GET',
    params: query
  })
}
// 管理员优卡充值
export function benfitAdvanceChange (params) {
  return fetch({
    url: '/benfitAdvance/advanceChange',
    method: 'post',
    params: params
  })
}
// 素材模板列表
export function sucaiList (query) {
  return fetch({
    url: '/sucai/list',
    method: 'get',
    params: query
  })
}
// 素材模板编辑
export function updateSucai (query) {
  return fetch({
    url: '/sucai/updateSucai',
    method: 'patch',
    params: query
  })
}
// 佣金翻倍
export function doubleCommission (query) {
  return fetch({
    url: '/activityconfig/doubleCommission',
    method: 'get',
    params: query
  })
}
// 佣金翻倍设置
export function updateDoubleCommission (query) {
  return fetch({
    url: '/activityconfig/updateDoubleCommission',
    method: 'post',
    params: query
  })
}
// 弹窗列表
export function tanchuangList (query) {
  return fetch({
    url: '/tanchuang/list',
    method: 'get',
    params: query
  })
}
// 弹窗设置
export function updateTanchuang (query) {
  return fetch({
    url: '/tanchuang/edit',
    method: 'post',
    params: query
  })
}

// 员工佣金批量申请提现到工资
export function handleUploadFile (query) {
  return fetch({
    url: '/stafftixian/import',
    method: 'post',
    data: query
  })
}

// 员工佣金回退（上传订单号 Excel）
export function staffCommissionRollback (query) {
  return fetch({
    url: '/stafftixian/commissionRollback',
    method: 'post',
    data: query
  })
}

// 加盟员工单提奖励佣金列表
export function franchiseStafftixianList (query) {
  return fetch({
    url: '/sharer/sharerfranchisestafftixian',
    method: 'get',
    params: query
  })
}

// 加盟员工单提奖励佣金信息导入
export function franchiseStafftixianUploadFile (query) {
  return fetch({
    url: '/sharer/sharerfranchisestafftixian/import',
    method: 'post',
    data: query
  })
}

// 加盟员工单提奖励佣金信息导出
export function franchiseStafftixianExport (query) {
  return fetch({
    url: '/sharer/sharerfranchisestafftixian/export',
    method: 'get',
    params: query
  })
}

// 获取商品推类列表
export function getSkuPromoteCateList (query) {
  return fetch({
    url: '/sharer/skupromotecate',
    method: 'get',
    params: query
  })
}

// 新增商品推类
export function createSkuPromoteCate (data) {
  return fetch({
    url: '/sharer/skupromotecate',
    method: 'post',
    data: data
  })
}

// 编辑商品推类
export function updateSkuPromoteCate (id, data) {
  return fetch({
    url: '/sharer/skupromotecate/' + id,
    method: 'put',
    data: data
  })
}

// 删除商品推类
export function deleteSkuPromoteCate (id) {
  return fetch({
    url: '/sharer/skupromotecate/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/sharer.js